import { createFileRoute, notFound } from "@tanstack/react-router";
import { getIndustry, industrySlugs } from "@/lib/industries";
import { IndustryPage } from "@/components/IndustryPage";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, serviceSchema, faqPage, breadcrumbList } from "@/lib/schema";

const AREA = [
  { type: "Country" as const, name: "Iraq" },
  { type: "Country" as const, name: "United Arab Emirates" },
  { type: "Country" as const, name: "Saudi Arabia" },
];

export const Route = createFileRoute("/ar/industries/$slug")({
  beforeLoad: ({ params }) => {
    if (!industrySlugs.includes(params.slug)) throw notFound();
  },
  head: ({ params }) => {
    const ind = getIndustry(params.slug);
    if (!ind || !industrySlugs.includes(params.slug)) return {};
    const path = `/ar/industries/${ind.slug}`;
    const url = absolute(path);
    return {
      meta: [
        { title: ind.metaTitle.ar },
        { name: "description", content: ind.description.ar },
        { property: "og:title", content: ind.metaTitle.ar },
        { property: "og:description", content: ind.description.ar },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:locale", content: "ar_IQ" },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [
        { rel: "canonical", href: url },
        ...hreflangLinks(`/industries/${ind.slug}`),
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            graph(
              serviceSchema({
                path,
                name: ind.title.ar,
                serviceType: `ISO certification for ${ind.name.en}`,
                description: ind.description.ar,
                areaServed: AREA,
              }),
              faqPage(
                path,
                ind.faq.map((f) => ({ q: f.q.ar, a: f.a.ar })),
              ),
              breadcrumbList([
                { name: "الرئيسية", path: "/ar" },
                { name: "قطاعات العمل", path: "/ar/industries" },
                { name: ind.name.ar, path },
              ]),
            ),
          ),
        },
      ],
    };
  },
  component: IndustryRoutePageAr,
});

function IndustryRoutePageAr() {
  const { slug } = Route.useParams();
  const ind = getIndustry(slug);
  if (!ind || !industrySlugs.includes(slug)) throw notFound();
  return <IndustryPage industry={ind} />;
}
